import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./style.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = ({ pdfUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [pdfData, setPdfData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch PDF data on component mount or when URL changes
  useEffect(() => {
    const fetchPdf = async () => {
      try {
        setLoading(true);
        
        // Create object URL from blob for PDF viewer
        const objectUrl = await fetchPdfAsObjectUrl(pdfUrl);
        setPdfData(objectUrl);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching PDF:", err);
        setError(err.message);
        setLoading(false);
      }
    };
    
    if (pdfUrl) {
      fetchPdf();
    }
    
    // Cleanup function to revoke object URL when component unmounts
    return () => {
      if (pdfData && pdfData.startsWith('blob:')) {
        URL.revokeObjectURL(pdfData);
      }
    };
  }, [pdfUrl]);

  // Helper function to fetch PDF as object URL
  const fetchPdfAsObjectUrl = async (url) => {
    // If your backend provides a proxy endpoint, use it like this:
    // const response = await fetch(`/api/pdf-proxy?url=${encodeURIComponent(url)}`);
    
    // For direct fetch (will only work if CORS is properly configured):
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF: ${response.statusText}`);
    }
    
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  };

  // Handle window resizing
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Calculate responsive PDF width
  const getPageWidth = () => {
    if (windowWidth > 1024) return 800;
    if (windowWidth > 768) return 600;
    return windowWidth * 0.9;
  };

  if (loading) return <div className="pdf-loading">Loading PDF...</div>;
  if (error) return <div className="pdf-error">Error loading PDF: {error}</div>;
  if (!pdfData) return <div className="pdf-error">No PDF to display</div>;

  return (
    <div className="pdf-container">
      <Document
        file={pdfData}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={(error) => console.error("Error loading PDF:", error)}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={getPageWidth()}
            renderTextLayer={true}
            renderAnnotationLayer={true}
          />
        ))}
      </Document>
    </div>
  );
};

export default PdfViewer;